/**
 * Loads the Klarna JavaScript SDK script dynamically.
 *
 * This composable checks for a Klarna client ID and loads the Klarna web SDK script
 * with the appropriate configuration. It uses the useScript composable for script loading.
 *
 * @returns {boolean|ScriptLoadResult} False if no client ID is available, otherwise returns the script loading result
 *
 * @example
 * const klarnaScriptStatus = useKlarnaScript()
 * if (klarnaScriptStatus) {
 *   // Klarna script is loaded and ready to use
 * }
 */
export const useKlarnaScript = () => {
  const appConfig = useAppConfig()
  const clientId = appConfig.currentMarketSettings.klarnaPlacementKey

  if (!clientId) return false

  return useScript({
    defer: true,
    'data-environment': 'production',
    src: 'https://js.klarna.com/web-sdk/v1/klarna.js',
    'data-client-id': clientId,
    key: 'Klarna',
  })
}
